import React, { useContext, useState, useEffect } from "react";
import Page from "../../../../_components/Layout/Page";
import Text from "../../../../_components/Text";
import Row from "../../../../_components/Layout/Row";
import Column from "../../../../_components/Layout/Column";
import LoadingInput from "../../../../_components/LoadingInput";
import Autocomplete from "../../POS/components/AutoComplete";
import { Button } from "react-bootstrap";
import TableComponent from "../components/tableComponent";
import CurrencyInput from "react-currency-input";
import Toast from '../../../../_components/Toast/index'
import { postPurchase } from "../../../../api/purchases";
import { formateCurrentDate, formatDate } from "../../../../utils";
import { getPaymentMethods } from "../../../../api/payments";
import AutoComplete from "../../Financial/AutoComplete";
import { getSuppliers } from "../../../../api/products";
import CreateSupplierModal from "../modals/createSupplierModal";
export default function CreatePurchase(props) {
    const [loading, SetLoading] = useState(false)
    const [supplierModal, setSupplierModal] = useState(false)
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [selectedPayMethod, setSelectedPayMethod] = useState('');
    const [itemPurchase, setItemPurchase] = useState([]);
    const [purchase, setPurchase] = useState({
        "discount_type": "cash",
        "invoice_type": 1,
        "total_amount": 0,
        "discount_value": 0,
        "paid_value": 0,
        "change": 0,
        "status": 1,
        "items": [],
        "payments": [],
        "deadline": formateCurrentDate(),
        "supplier": "",
        "freight": 0.0,
    });
    const [toast, setToast] = useState({
        message: "",
        show: false
    })

    function onChange(event, floatValue) {
        let { name, value } = event.target;
        let tempData = { ...purchase };

        if (floatValue !== undefined) {
            value = floatValue; 
        }

        if (name.includes(':')) {
            const [key, child] = name.split(':');
            tempData[key][child] = value;
        } else {
            tempData[name] = value;
        }
        setPurchase(tempData);
    }



    useEffect(() => {
        getPaymentMethods().then((data) => {
            setPaymentMethods(data);
            setSelectedPayMethod(data[0])
        }).catch(() => {
        });
    }, []);

    function addItemToPurchase(e) {
        let tempData = { ...purchase };
        let itemIndex = tempData.items.findIndex(obj => obj.id === e.id);
        if (itemIndex !== -1) {
            tempData.items[itemIndex].quantity += 1;
        } else {
            tempData.items.push(e);
        }
        setPurchase(tempData);
        setItemPurchase([...tempData.items]);
    }

    function addPayment(tempData) {
        const totalAmount = parseFloat(tempData.total_amount) || 0; 
        tempData.payments.push({
            displayValue: "R$" + totalAmount.toFixed(2),
            paymentName: selectedPayMethod.name,
            payment_method: selectedPayMethod.id,
            value: totalAmount.toFixed(2) 
        });
        return tempData;
    }


    function isInputFilled() {
        return (purchase.freight !== null && purchase.supplier !== null && purchase.items.length > 0);
    }

    function _createPurchase() {
        SetLoading(true)
        if (!isInputFilled()) {
            SetLoading(false)
            setToast({
                message: "Preencha todos os campos corretamente!",
                show: true
            })
            setTimeout(() => {
               setToast({
                    message: "",
                    show: false
               })
            }, 3000);
            return;
        }
        let tempData = { ...purchase };
        tempData.total_amount = itemPurchase.reduce((acc, item) => acc + (item.sellable.price * item.quantity), 0);
        tempData.total_amount += parseFloat(purchase.freight) || 0; 
        tempData = addPayment(tempData);
        postPurchase(tempData)
            .then(resp => {
                setToast({
                    message: "Compra criada com sucesso!",
                    show: true
                });
                setTimeout(() => {
                    window.location.href = '/purchases';
                }, 4000);
            SetLoading(false)
            })
            .catch(e => {
                tempData.payments = [];
                setToast({
                    message: "Erro na criação da compra! Por favor, tente novamente.",
                    show: true
                });
                setTimeout(() => {
                    setToast({
                        message: "",
                        show: false
                    });
                }, 4000);
            SetLoading(false)
                setPurchase(tempData);
                SetLoading(false)
            });
    }


    function onChangePayMethod(e) {
        const selectedMethod = paymentMethods.find(method => method.name === e.target.value);
        setSelectedPayMethod(selectedMethod);
    }

    function onRemoveItem(id) {
        let tempData = { ...purchase };
        tempData.items = tempData.items.filter(item => item.id !== id);
        setPurchase(tempData);
        setItemPurchase([...tempData.items]);
    }

    return (
        <Page className="text-center">
            <Row className='d-flex justify-content-between m-1'>
            <Text fontSize={"lg"}>Criar compra</Text>
                <Button onClick={() => setSupplierModal(true)}>Criar fornecedor</Button>
            </Row>
            <Row>
                <Column xs="12" md="4" lg="6">
                    <Text className='mt-2'>Fornecedor</Text>
                    <AutoComplete
                            request={(...args) => getSuppliers(...args).then(result => {
                                return result.map(item => ({
                                    ...item,
                                    'name': item.name
                                }));
                            })}
                            disabled={loading}
                            searchField='name'
                            labelField='name'
                            valueField='id'
                            placeholder='fornecedor'
                            onSelect={(data)=>{
                                let tempData = {...purchase}
                                tempData.supplier = data.value
                                setPurchase({...tempData})
                            }
                            }
                        />
                </Column>
                <Column xs="12" md="4" lg="6">
                    <Text className='mt-2'>Frete</Text>
                    <CurrencyInput
                        required
                        disabled={loading}
                        prefix="R$ "
                        className="form-control"
                        decimalSeparator=","
                        thousandSeparator="."
                        data-cy-test="#financial-input-payin-value"
                        precision="2"
                        name='freight'
                        onChangeEvent={onChange}
                        value={purchase.freight}
                    />
                </Column>

                <Column xs="12" md="4" lg="6">
                    <Text className='mt-2'>Prazo de entrega</Text>
                    <LoadingInput name="deadline" disabled={loading} onChange={onChange} value={purchase.deadline} type="date" />
                </Column>
                <Column xs="12" md="4" lg="6">
                    <Text className='mt-2'>Forma de pagamento</Text>
                    <LoadingInput disabled={loading} onChange={onChangePayMethod} name="payMethod" as="select" defaultValue={'Dinheiro'}>
                        {paymentMethods.map((value, _) => <option key={value.name} value={value.name}>{value.name}</option>)}
                    </LoadingInput>
                </Column>
            </Row>
            <Column>
                <Autocomplete onClick={addItemToPurchase} disabled={loading}/>
                {itemPurchase.length ? (
                    <TableComponent
                        data={itemPurchase}
                        currentPurchase={purchase}
                        onRemoveItem={onRemoveItem}
                    />
                ) : (
                    <div></div>
                )}
            </Column>
            <Button onClick={_createPurchase} disabled={loading}>Fazer compra</Button>
            

            {
                <Toast
                    message={toast.message}
                    show={toast.show}
                />
            }

            {
                <CreateSupplierModal
                    show={supplierModal}
                    onHide={() => {setSupplierModal(false)}}
                    onSave={(toastText) => {
                        setToast({
                            show: true,
                            message: toastText
                        })
                        setTimeout( () => {
                            setToast({
                                show: false
                            })
                        }, 4000)
                    }}
                />
                    
            }
            
        </Page>
    );
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Purchases/createPurchase/index.jsx